var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFoldingRule = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 16
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1191D6",
  d: "M11.584 15.802L8.58 14.558a.904.904 0 01-.5-1.207L13.779.68c.208-.466.771-.68 1.256-.48l3.004 1.244c.485.2.708.74.499 1.207L12.84 15.323c-.21.465-.772.68-1.257.479"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4DA40",
  d: "M16.34 2.904a.69.69 0 01-.892.34.642.642 0 01-.354-.856.69.69 0 01.892-.34.641.641 0 01.354.856m-4.825 10.73a.69.69 0 01-.891.34.641.641 0 01-.354-.856.69.69 0 01.891-.34.641.641 0 01.354.856"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#231F20",
  strokeWidth: 0.5,
  d: "M9.7 10.832l2.268.94"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeWidth: 0.5,
  d: "M10.794 8.4l2.268.94m-1.175-3.372l2.268.94M12.98 3.536l2.268.94"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1191D6",
  d: "M3.581 15.802L.578 14.558a.904.904 0 01-.5-1.207L5.776.68C5.985.214 6.548 0 7.033.2l3.003 1.244c.485.2.709.74.5 1.207L4.839 15.323c-.21.465-.772.68-1.258.479"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4DA40",
  d: "M8.337 2.904a.69.69 0 01-.891.34.642.642 0 01-.354-.856.69.69 0 01.891-.34.641.641 0 01.354.856"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFEA6F",
  d: "M3.513 13.634a.69.69 0 01-.891.34.641.641 0 01-.354-.856.69.69 0 01.891-.34.641.641 0 01.354.856"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeWidth: 0.5,
  d: "M1.699 10.832l2.267.94M2.792 8.4l2.268.94M3.885 5.968l2.268.94M4.978 3.536l2.268.94"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5AC0F7",
  d: "M13.121 15.026l-3.135.896c-.507.144-1.04-.132-1.19-.619L4.695 2.076c-.151-.486.137-.998.644-1.142L8.474.038c.506-.144 1.039.133 1.19.619l4.101 13.227c.15.486-.137.997-.644 1.142"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFEA6F",
  d: "M8.147 2.204a.647.647 0 01-.457.81.683.683 0 01-.844-.438.647.647 0 01.457-.81.683.683 0 01.844.438m3.473 11.202a.647.647 0 01-.457.81.684.684 0 01-.843-.439.647.647 0 01.456-.81.683.683 0 01.844.439"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeWidth: 0.5,
  d: "M8.355 12.374l2.367-.676M7.568 9.835l2.367-.676M6.78 7.296l2.368-.676M5.993 4.758l2.368-.676"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5AC0F7",
  d: "M21.261 15.026l-3.135.896c-.507.144-1.04-.132-1.19-.619L12.835 2.076c-.151-.486.137-.998.643-1.142l3.136-.896c.506-.144 1.039.133 1.19.619l4.101 13.227c.15.486-.137.997-.644 1.142"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFEA6F",
  d: "M16.287 2.204a.647.647 0 01-.457.81.683.683 0 01-.844-.438.647.647 0 01.457-.81.683.683 0 01.844.438m3.473 11.202a.647.647 0 01-.457.81.684.684 0 01-.844-.439.647.647 0 01.457-.81.683.683 0 01.844.439"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeWidth: 0.5,
  d: "M16.495 12.374l2.367-.676m-3.155-1.863l2.368-.676M14.92 7.296l2.368-.676m-3.155-1.862l2.367-.676"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#107FBB",
  d: "M11.347 6.086l.355-.796 2.314 7.411-.364.818zm-6.47-3.414l2.306 7.43-.322.716-2.307-7.427zm8.086-.182l2.305 7.434-.348.773-2.3-7.441z"
}))));
export default SvgFoldingRule;